exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".button-back .MuiButton-outlined{padding:6px 27px}.button-next .MuiButton-contained{padding:6px 27px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Common/BackNextButton.scss
// module id = 1778
// module chunks = 101